import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import { CompactLayout } from 'src/layouts';

// HOME
const HomePage = lazy(() => import('src/modules/home/components/home'));

// QR CODE
const ReadQrCodePage = lazy(() => import('src/modules/qr-code/components/read-qr-code'));

// POINTS
const AddPointsPage = lazy(() => import('src/modules/points/components/add-points'));

// BENEFITS
const UserRedeemsPage = lazy(() => import('src/modules/benefits/components/user-redeems'));

// CAMPAIGN REWARDS
const UserCampaignRewardsPage = lazy(() => import('src/modules/campaign-rewards/components/user-campaign-rewards'));

export const webAppRoutes = [
  {
    path: 'webapp',
    element: (
      <CompactLayout>
        <AuthGuard>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AuthGuard>
      </CompactLayout>
    ),
    children: [
      {
        path: 'home',
        element: <HomePage />,
      },
      {
        path: 'benefits',
        children: [
          {
            path: 'read-qr-code',
            element: <ReadQrCodePage />,
          },
          {
            path: 'user-redeems/:userCode',
            element: <UserRedeemsPage />,
          },
        ],
      },
      {
        path: 'campaigns',
        children: [
          {
            path: 'read-qr-code',
            element: <ReadQrCodePage />,
          },
          {
            path: 'user-rewards/:userCode',
            element: <UserCampaignRewardsPage />,
          },
        ],
      },
      {
        path: 'points',
        children: [
          {
            path: 'read-qr-code',
            element: <ReadQrCodePage />,
          },
          {
            path: 'add/:userCode',
            element: <AddPointsPage />,
          },
        ],
      },
    ],
  },
];
